module.exports = __webpack_public_path__ + "img/2012-08-18 13.52.24.d2661b35.jpg";